var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaiserlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 92 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 53.08L0 46.09L46.09 0L91.31 45.22L84.31 52.22L46.09 13.99L7 53.08Z",
    fill: "url(#paint0_linear_491_1977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.43 68.24L46.09 41.9L19.78 68.2L12.79 61.2L46.09 27.9L79.42 61.24L72.43 68.24Z",
    fill: "url(#paint1_linear_491_1977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.04 76.68L46.11 59.79L29.23 76.68H43.87H43.84H48.4H48.35H63.04Z",
    fill: "url(#paint2_linear_491_1977)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_1977",
    x1: 0,
    y1: 26.54,
    x2: 91.31,
    y2: 26.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F89D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE488C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_491_1977",
    x1: 12.79,
    y1: 48.07,
    x2: 79.42,
    y2: 48.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F89D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE488C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_491_1977",
    x1: 29.23,
    y1: 68.24,
    x2: 63.04,
    y2: 68.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F89D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE488C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.31,
    height: 76.68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiserlogo);
export default __webpack_public_path__ + "static/media/raiserlogo.858562b11fac31efce27638ba70588e2.svg";
export { ForwardRef as ReactComponent };